import type { VNode } from 'vue';
import { h } from 'vue';
import { useIconThemeColor } from './use-props';

export interface SVGJson {
  tag: string;
  attrs: Record<string, any>;
  children?: SVGJson[];
  [key: string]: any;
}
export interface TreeObj {
  isProps: boolean;
  children?: TreeObj[];
  fill?: string;
  color?: string;
}
export function renderFn(node: SVGJson, props: Record<string, any>, colorProps: any): VNode {
  const _colorProps = {};
  if (colorProps && colorProps.isProps) {
    const { isProps, children, ...finalColor } = colorProps;
    Object.assign(_colorProps, finalColor);
  }
  if (typeof colorProps === 'string') {
    Object.assign(_colorProps, { color: colorProps, fill: 'currentColor' });
  }
  return h(
    node.tag,
    {
      ...node.attrs,
      ...props,
      ..._colorProps,
    },
    (node.children || []).map((child: SVGJson, index: number) => {
      return renderFn(
        child,
        {},
        typeof colorProps === 'string'
          ? colorProps
          : colorProps?.children
          ? colorProps.children[index]
          : {},
      );
    }),
  );
}
export function formatColor(color: string | string[]) {
  if (typeof color === 'string') {
    return useIconThemeColor.has(color) ? useIconThemeColor.get(color) : color;
  }
  const treeObj: TreeObj = {
    isProps: false,
  };
  treeObj.children = color.map((stringColor: string) => {
    const resultColor = useIconThemeColor.has(stringColor)
      ? useIconThemeColor.get(stringColor)
      : stringColor;
    return {
      isProps: true,
      fill: 'currentColor',
      color: resultColor,
    };
  });
  return treeObj;
}
